/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Step_ConfirmInputs */

const en_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const fr_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const de_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const it_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confermare`)
};

const ru_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждать`)
};

const es_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const zh_cn2_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

const ja_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認する`)
};

const hi_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुष्टि करना`)
};

const pt_pt2_new_project_step_confirm = /** @type {(inputs: New_Project_Step_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {New_Project_Step_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_step_confirm = /** @type {((inputs?: New_Project_Step_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Step_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_step_confirm(inputs)
	if (locale === "de") return de_new_project_step_confirm(inputs)
	if (locale === "it") return it_new_project_step_confirm(inputs)
	if (locale === "ru") return ru_new_project_step_confirm(inputs)
	if (locale === "es") return es_new_project_step_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_step_confirm(inputs)
	if (locale === "ja") return ja_new_project_step_confirm(inputs)
	if (locale === "hi") return hi_new_project_step_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_step_confirm(inputs)
	return en_new_project_step_confirm(inputs)
});